__turbopack_context__.v({
  "currentPage": "results-and-map-wrapper-module__WYHawG__currentPage",
  "fallbackNotice": "results-and-map-wrapper-module__WYHawG__fallbackNotice",
  "gridContainer": "results-and-map-wrapper-module__WYHawG__gridContainer",
  "mapSection": "results-and-map-wrapper-module__WYHawG__mapSection",
  "pageInfo": "results-and-map-wrapper-module__WYHawG__pageInfo",
  "pageSeparator": "results-and-map-wrapper-module__WYHawG__pageSeparator",
  "pagination": "results-and-map-wrapper-module__WYHawG__pagination",
  "paginationButton": "results-and-map-wrapper-module__WYHawG__paginationButton",
  "pdfButton": "results-and-map-wrapper-module__WYHawG__pdfButton",
  "radiusChip": "results-and-map-wrapper-module__WYHawG__radiusChip",
  "radiusChipActive": "results-and-map-wrapper-module__WYHawG__radiusChipActive",
  "radiusChips": "results-and-map-wrapper-module__WYHawG__radiusChips",
  "radiusLabel": "results-and-map-wrapper-module__WYHawG__radiusLabel",
  "resultsAndMapWrapper": "results-and-map-wrapper-module__WYHawG__resultsAndMapWrapper",
  "resultsInfo": "results-and-map-wrapper-module__WYHawG__resultsInfo",
  "resultsSection": "results-and-map-wrapper-module__WYHawG__resultsSection",
  "totalPages": "results-and-map-wrapper-module__WYHawG__totalPages",
});
